"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.customStyles = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _colors = require("../../../theme/colors");

var _themeProvider = _interopRequireDefault(require("../../../theme/theme-provider"));

function optionBackground(isDisabled, isSelected, isFocused, isMulti) {
  if (isDisabled) {
    return _themeProvider["default"].palette.text.disabled;
  }

  if (isSelected) {
    if (isMulti) {
      return null;
    }

    return _colors.opacity.primary[500][14];
  }

  return null;
}

var customStyles = {
  clearIndicator: function clearIndicator() {
    return {
      cursor: 'pointer'
    };
  },
  input: function input(provided) {
    return (0, _objectSpread2["default"])({}, provided, {
      margin: 0
    });
  },
  menu: function menu(provided) {
    return (0, _objectSpread2["default"])({}, provided, {
      marginTop: 0,
      maxHeight: 300
    });
  },
  option: function option(provided, _ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected,
        isMulti = _ref.isMulti;
    return (0, _objectSpread2["default"])({}, provided, {
      ':active': {
        backgroundColor: isMulti ? null : _colors.opacity.primary[500][14]
      },
      ':hover': {
        backgroundColor: _colors.opacity.black[8]
      },
      backgroundColor: optionBackground(isDisabled, isSelected, isFocused, isMulti),
      height: 32,
      padding: '0px 11px'
    });
  }
};
exports.customStyles = customStyles;

var styles = function styles(theme) {
  return {
    chipWrapper: {
      padding: theme.spacing.unit * (1 / 4)
    },
    disabled: {},
    divider: {
      margin: 0
    },
    dropdownIndicatorHover: {
      color: theme.palette.text.primary
    },
    dropdownIndicatorRoot: {
      color: theme.palette.text.secondary
    },
    error: {},
    focused: {},
    indicatorSeparator: {
      display: 'none'
    },
    input: {
      '&$disabled': {
        background: _colors.opacity.black[8]
      },
      '&:hover:not($disabled):not($focused):not($error)': {
        background: _colors.opacity.black[8]
      },
      borderRadius: '2px 2px 0 0',
      display: 'flex',
      height: 36,
      minWidth: 222,
      padding: 0
    },
    inputComponent: {
      backgroundColor: _colors.opacity.black[4],
      'label + &': {
        marginTop: 20
      },
      marginBottom: 4
    },
    inputLabel: (0, _objectSpread2["default"])({}, theme.typography.overline, {
      '&$error': {
        color: theme.palette.error.dark
      },
      color: theme.palette.text.secondary
    }),
    inputUnderlined: {
      '&$disabled:before': {
        borderBottom: 'none'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.dark
      }
    },
    menu: {
      minWidth: 280,
      width: '100%'
    },
    multiInput: {
      '&:hover': {
        background: 'auto'
      },
      borderRadius: '2px 2px 0 0',
      display: 'flex',
      height: 36,
      minWidth: 264,
      padding: 0,
      paddingLeft: 16,
      width: '100%'
    },
    multiSelectCheckbox: {
      marginLeft: theme.spacing.unit * -1,
      marginRight: theme.spacing.unit
    },
    option: {
      '&$disabled': {
        color: theme.palette.text.disabled,
        fontWeight: 400
      },
      '&$focused': {
        fontWeight: 400
      },
      '&$selected': {
        background: 'none',
        fontWeight: 400
      },
      '&$selected:hover': {
        background: 'none'
      },
      '&:hover': {
        background: 'none'
      },
      color: theme.palette.text.primary,
      fontWeight: 400,
      paddingLeft: 5
    },
    paper: {
      borderRadius: '0 0 2px 2px',
      boxShadow: theme.shadows[4],
      minWidth: 221,
      paddingBottom: 4,
      paddingTop: 2
    },
    placeholder: {
      color: theme.palette.text.hint,
      left: 16,
      position: 'absolute'
    },
    selected: {},
    singleValue: {
      color: theme.palette.text.primary,
      left: 16,
      position: 'absolute'
    },
    valueContainer: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      overflow: 'hidden'
    }
  };
};

exports.styles = styles;